(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'libphonenumber-js'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('libphonenumber-js'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.libphonenumberJs);
    global.index = mod.exports;
  }
})(this, function (exports, _libphonenumberJs) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.required = exports.isPhoneNumberValid = exports.email = undefined;
  var email = exports.email = function email(value) {
    return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? 'Invalid email address' : undefined;
  };

  var isPhoneNumberValid = exports.isPhoneNumberValid = function isPhoneNumberValid(phoneNumber) {
    var parsed = (0, _libphonenumberJs.parseNumber)(phoneNumber, 'US');
    return !!phoneNumber && !!parsed.phone;
  };

  var required = exports.required = function required(value) {
    return value ? undefined : 'Required';
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/form/validators/index.js
// module id = 537
// module chunks = 1